const NEW_URL = "https://ccs-ipcc.indonesiacarterminal.co.id/";
const NEW_URL_LABEL = NEW_URL.replace(/^https:\/\/|\/$/g, "");

/**
 * Satu-satunya halaman di alamat lama: Customer Portal sudah pindah server. Dipasang langsung di index.js,
 * jadi semua alamat menampilkan halaman ini dan tidak ada panggilan API.
 */
function Moved() {
  return (
    <main
      className="min-h-screen w-full bg-cover bg-center flex items-center justify-center p-4 sm:p-6"
      style={{
        backgroundImage:
          "linear-gradient(rgba(6, 75, 130, .82), rgba(6, 75, 130, .82)), url(/images/bg-ikt-compres.jpg)",
      }}
    >
      <section className="w-full max-w-2xl rounded-2xl bg-white p-6 sm:p-10 shadow-xl text-gray-800">
        <header className="text-center pb-5 border-b border-gray-200">
          <img
            src="/images/logo_ipcc.png"
            alt="PT Indonesia Kendaraan Terminal Tbk"
            className="h-14 mx-auto mb-4"
          />
          <h1 className="text-2xl sm:text-3xl font-bold leading-tight text-blue-primary">
            Pemberitahuan Perpindahan Alamat Website
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Customer Portal PT Indonesia Kendaraan Terminal Tbk
          </p>
        </header>

        <div className="mt-5 space-y-4 text-sm sm:text-base leading-relaxed">
          <p>Yth. Bapak/Ibu Pelanggan,</p>
          <p>
            Dalam rangka peningkatan kualitas layanan, kami informasikan bahwa Customer Portal telah{" "}
            <b>berpindah ke alamat website yang baru</b>. Alamat yang sedang Bapak/Ibu buka saat ini
            sudah tidak digunakan.
          </p>

          <div className="rounded-xl border border-blue-100 bg-blue-50 p-4 text-center">
            <p className="text-xs uppercase tracking-wide text-gray-500">Alamat website baru</p>
            <a
              href={NEW_URL}
              className="mt-1 block break-all text-lg sm:text-xl font-bold text-blue-primary"
            >
              {NEW_URL_LABEL}
            </a>
          </div>

          <p>
            Mohon gunakan alamat tersebut untuk seluruh layanan Customer Portal dan perbarui{" "}
            <i>bookmark</i> pada perangkat Bapak/Ibu.
          </p>
          <p>Atas perhatian dan kerja sama Bapak/Ibu, kami ucapkan terima kasih.</p>
          <p>
            Hormat kami,
            <br />
            <b>PT Indonesia Kendaraan Terminal Tbk</b>
          </p>
        </div>

        <div className="mt-6 text-center">
          <a
            href={NEW_URL}
            className="inline-block rounded-lg bg-blue-primary px-6 py-3 font-semibold text-white"
          >
            Buka Alamat Baru
          </a>
        </div>
      </section>
    </main>
  );
}

export default Moved;
